export default "__VITE_ASSET__1eb53131__"